import React from "react";
import { observer } from "mobx-react";
import SelectableItemsList from "../ratecards/components/SelectableItemsList";
import SelectableItem from "../ratecards/components/SelectableItem";
import ContainerSection from "../ratecards/components/ContainerSection";
import FilterModal, { ModalTitle } from "../ratecards/components/FilterModal";
import LoadingIndicator from "../shared/LoadingIndicator";
import SortControls from "../ratecards/components/SortControls";
import InstantSearchBox from "../ratecards/components/InstantSearchBox";
import Inline from "../../components/lib/Inline";
import Spacer from "../../components/lib/Spacer";
import Button from "../../components/lib/Button";

const IndustryCriteriaList = observer((props) => (
  <div>
    <SelectableItemsList className="overlap-tb-padding">
      {props.filterState.viewItems.map((item, i) => (
        <SelectableItem
          key={item.id}
          item={item}
          name="industry-filter"
          value={item.industry}
          selected={item.selected}
          onChange={props.filterState.setSelectedValue}
        >
          <div>{item.industry}</div>
        </SelectableItem>
      ))}
    </SelectableItemsList>
    <ContainerSection className="info">
      <p className="text-muted text-x-small no-margin pull-right">
        <em>
          <strong>{props.filterState.selectedValuesCount} </strong>
          selected, <strong>{props.filterState.totalValuesCount} </strong>
          total
        </em>
      </p>
      <div className="clearfix" />
    </ContainerSection>
  </div>
));

const IndustryFilter = ({
  industryFilter,
  network,
  onInstantSearch,
  instantSearchValue,
}) => {
  return (
    <FilterModal filterState={industryFilter}>
      {network && <LoadingIndicator />}
      {!network && (
        <div>
          <ContainerSection className="header overlap-t-padding">
            <ModalTitle className="pull-left">Industry</ModalTitle>
            <div className="pull-right">
              <SortControls filterState={industryFilter} />
            </div>
            <div className="clearfix" />
          </ContainerSection>
          <ContainerSection className="no-border">
            <p>Filter by specific Industry:</p>
            <Inline css={{ gap: "$2" }}>
              <InstantSearchBox onSearch={onInstantSearch} value={instantSearchValue} />
              <Spacer />
              <Button onClick={industryFilter.onSelectAll}>Select All</Button>
              <Button onClick={industryFilter.onDeselectAll}>Deselect All</Button>
            </Inline>
          </ContainerSection>
          <IndustryCriteriaList filterState={industryFilter} />
        </div>
      )}
    </FilterModal>
  );
};

export default IndustryFilter;
